import React from 'react';

const PageCustomizationContext = React.createContext({ sidebarMarkup: null });

export default PageCustomizationContext;
